import { jsx } from 'react/jsx-runtime';
import { Space } from '@sravni/react-design-system';
import modules_fe7e3e93 from './OfferParams.module.scss.js';

var OfferParams = function (_a) {
    var children = _a.children;
    return jsx(Space, { className: modules_fe7e3e93.wrapper, wrap: true, children: children });
};

export { OfferParams };
//# sourceMappingURL=OfferParams.js.map
